

export const PanaToursPage = () => {
  return (
    <div>PanaToursPage</div>
  )
}
